<template>
  <div class="box">
    <div class="content">
      <div class="danwei_not" v-if="row.danwei.registstatus == 0">
        <h1>单位认证</h1>
        <h2>关联CCA单位信息，完成后可获得单位相关业务 <br />权限</h2>
        <div class="goDanwei" v-rblink="{ name: 'CertDanwei' }">立即认证</div>
      </div>
      <div class="danwei" v-if="row.danwei.registstatus != 0">
        <h1>{{ row.danwei.name }}</h1>
        <h2>关联CCA单位信息，完成后可获得单位相关业务 <br />权限</h2>
        <div class="br"></div>
        <van-cell-group>
          <van-field
            value=""
            label="运动员管理"
            label-width="150"
            is-link
            input-align="right"
            readonly
            v-rblink="{ name: 'YundongyuanList' }"
          />
          <van-field
            value=""
            label="随队裁判员管理"
            label-width="150"
            is-link
            input-align="right"
            readonly
            v-rblink="{ name: 'CaipanList' }"
          />
          <van-field
            value=""
            label="随队教练员管理"
            label-width="150"
            is-link
            input-align="right"
            readonly
            v-rblink="{ name: 'JiaolianList' }"
          />
        </van-cell-group>
        <div style="display: flex">
          <div
            class="delete_danwei"
            v-if="row.danwei.registstatus == 2"
            style="margin-top: 0"
            @click="unbind"
          >
            解除认证
          </div>
          <div
            class="goDanwei"
            v-if="row.danwei_list.length > 1"
            @click="sheetActiveShow = true"
            style="margin-top: 0"
          >
            更换单位
          </div>
          <div
            class="goDanwei" 
            v-if="row.danwei_list.length > 0"
             v-rblink="{ name: 'CertDanwei',query:{new:1} }"
            style="margin-top: 0 ;margin-left:10px"
          >
            新增认证
          </div>
        </div>
      </div>
      <div class="num_not" v-if="row.cert.status == 0">
        <h1>实名认证</h1>
        <h2>关联CCA单位信息，完成后可获得单位相关业务 <br />权限</h2>
        <div class="goNum" @click="showNumTypePicker = true">立即认证</div>
      </div>
      <div class="num" v-if="row.cert.status == 1">
        <h1>{{ row.cert.user_name }}-{{ row.cert.user_code }}</h1>
        <h2>关联CCA单位信息，完成后可获得单位相关业务 <br />权限</h2>
        <div class="delete_danwei" @click="unbindPerson">解除认证</div>
      </div>
      <div class="manage">
        <h1>证件照管理</h1>
        <h2>裁判员、教练员等证书照片显示</h2>
        <div class="goNum" v-rblink="{ name: 'CertPersonPhoto' }">去管理</div>
      </div>
      <div class="manage" v-if="row.weiyuanhui_list.length > 0">
        <h1>省市管理</h1>
        <h2>管理赛事、会议、七彩星级、俱乐部、大课间等信息</h2>
        <div class="goNum" v-rblink="{ name: 'WeiyuanhuiList' }">去选择</div>
      </div>
      <div class="manage" v-if="row.wa_fl">
        <h1>区域合伙人管理</h1>
        <h2>个人在所在区域内所有销售业务管理</h2>
        <div class="goNum" v-rblink="{ name: 'WyhConfigureList' }">去管理</div>
      </div>
      <div class="manage" v-if="row.pa_fl">
        <h1>个人合伙人管理</h1>
        <h2>个人所有销售业务管理</h2>
        <div class="goNum" v-rblink="{ name: 'ConfigureList' }">去管理</div>
      </div>
      <div class="manage" v-if="row.fa_fl">
        <h1>省服务专员</h1>
        <h2>所联络的省份的所有销售订单管理</h2>
        <div class="goNum" v-rblink="{ name: 'WyhConfigureList' }">管理订单</div>
      </div>
      <div class="manage" v-if="row.user_fl">
        <h1>公司内部管理</h1>
        <h2>CCA公司内部业务管理：销售订单管理，推荐订单管理</h2>
        <div class="goNum" v-rblink="{ name: 'ConfigureList' }">去管理</div>
      </div>
    </div>
    <van-popup v-model="showNumTypePicker" position="bottom">
      <van-picker
        :columns="numTypeColumns"
        show-toolbar
        title="实名验证类型选择"
        @cancel="showNumTypePicker = false"
        @confirm="onNumTypeConfirm"
      />
    </van-popup>
    <van-action-sheet
      v-model="sheetActiveShow"
      description="将以新的单位为主体参赛报名"
      :actions="row.danwei_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelect"
    />
  </div>
</template>
<style scoped>
.box {
  /* height: 20rem; */
  height: 100%;
  overflow: scroll;
  padding-bottom: 1rem;
  background: #f0eff4;
}
.van-cell-group {
  margin: 0;
}
.van-cell {
  padding: 18px 0;
}
.van-cell:not(:last-child)::after {
  left: 0;
}
.br {
  height: 1px;
  background: #ebedf0;
  margin-top: 10px;
}
.content {
  padding: 0.2rem;
  padding-top: 0.3rem;
}
.danwei_not {
  height: 2.8rem;
  background-image: url("../../../../assets/images/bg-danweirenzehng-no@2x.png");
  background-size: 100% 100%;
  padding: 0.3rem;
  padding-bottom: 0;
}
.danwei {
  height: 6.35rem;
  background-image: url("../../../../assets/images/bg-danweirenzheng-yes@2x.png");
  background-size: 100% 100%;
  padding: 0.3rem;
  padding-bottom: 0;
}
.danwei_not h1 {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
}
.danwei_not h2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 0.2rem;
}
.danwei h1 {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
}
.danwei h2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 0.2rem;
}
.goDanwei {
  width: 86px;
  height: 32px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  margin-top: 0.4rem;
  text-align: center;
}
.num_not {
  height: 2.8rem;
  background-image: url("../../../../assets/images/bg-gerenrenzheng-no@2x.png");
  background-size: 100% 100%;
  padding: 0.3rem;
  padding-bottom: 0;
  margin-top: 0.2rem;
}
.num_not h1 {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
}
.num_not h2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 0.2rem;
}
.num {
  height: 2.8rem;
  background-image: url("../../../../assets/images/bg-gerenrenzheng-yes@2x.png");
  background-size: 100% 100%;
  padding: 0.3rem;
  padding-bottom: 0;
  margin-top: 0.2rem;
}
.num h1 {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
}
.num h2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 0.2rem;
}
.goNum {
  width: 86px;
  height: 32px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  margin-top: 0.4rem;
  text-align: center;
}
.delete_danwei {
  width: 86px;
  height: 32px;
  border: 1px solid #f7b500;
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #f7b500;
  line-height: 32px;
  margin-top: 0.4rem;
  text-align: center;
  margin-right: 0.3rem;
}
.manage {
  /* height: 2.5rem; */
  padding: 0.3rem;
  padding-bottom: 0.5rem;
  margin-top: 0.2rem;
  background: #ffffff;
  border-radius: 10px;
}
.manage h1 {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
}
.manage h2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 0.2rem;
}
</style>
<script>
import Vue from "vue";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(Dialog)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "CertIndex",
  components: {
    PicUploader,
    LoginDialog,
  },
  data: function () {
    return {
      sheetActiveShow: false,
      sheetActiveActions: [{ name: "单位1" }],
      loginShow: false,
      saveLoading: false,
      showArea: false,
      showNumTypePicker: false,
      areaList: {},
      areaValue: "",
      submitType: "",
      row: {
        weiyuanhui_list: [],
        danwei_list: [],
        danwei: {},
        exame_center: {},
        club: {},
        cert: {
          status: 0,
        },
        photo: {},
      },
      formData: {},
      numTypeColumns: ["身份证", "护照", "其他身份证明"],
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "认证首页";
    this.fetch();
  },
  watch: {},
  destroyed() {},
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },
    onSheetCancel() {
      // Toast('取消');
    },
    onSelect(action, index) {
      console.log(action, index);
      let that = this;
      that.$api.post(
        "/api/user/danweiChange",
        {
          danwei_id: action.id,
        },
        (res) => {
          Toast("您的备案单位已切换成【" + action.name + "】");
          that.fetch();
        },
        (res) => {}
      );
    },
    fetch() {
      let that = this;
      that.$api.post(
        "/api/user/certindex",
        {},
        (res) => {
          that.row = res.data;
        },
        (res) => {
          console.log("errrrrr");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    unbind() {
      let that = this;
      Dialog.confirm({
        title: "确认",
        message: "确认要解除单位认证吗?",
      })
        .then(() => {
          that.$api.post(
            "/api/danwei/unbind",
            {},
            (res) => {
              that.fetch();
            },
            (res) => {}
          );

          //                    that.onPaySuccess();
        })
        .catch(() => {
          //                    that.onPayError();
        });
    },

    unbindPerson() {
      let that = this;
      Dialog.confirm({
        title: "确认",
        message: "确认要解除个人认证吗?",
      })
        .then(() => {
          that.$api.post(
            "/api/user/unbind",
            {},
            (res) => {
              that.fetch();
            },
            (res) => {}
          );

          //                    that.onPaySuccess();
        })
        .catch(() => {
          //                    that.onPayError();
        });
    },

    onNumTypeConfirm(value, index) {
      console.log("onNumTypeConfirm", value, index);
      this.showNumTypePicker = false;

      let name = "CertPersonApply";
      if (value != "身份证") {
        name = "CertPersonApplyOther";
      }

      rbLink({
        name: name,
      });
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// MyInfo.vue?0a245b36